import type { CategoriesData } from '../types';

export function buildCategorySelectData(catData: CategoriesData | undefined) {
  return (catData?.category_groups ?? []).map((g) => ({
    group: g.label_da,
    items: (catData?.categories ?? [])
      .filter((c) => c.group === g.id)
      .map((c) => ({ label: c.label_da, value: c.id })),
  }));
}
